import { __awaiter, __generator } from "tslib";
export function importPolyfill() {
    return __awaiter(this, void 0, void 0, function () {
        var module;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import(
                    /* webpackChunkName: 'text-encoder-lite' */
                    "@lpi/text-encoder-lite")];
                case 1:
                    module = _a.sent();
                    return [2 /*return*/, module.default];
            }
        });
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1wb3J0UG9seWZpbGwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW1wb3J0UG9seWZpbGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE1BQU0sVUFBZ0IsY0FBYzs7Ozs7d0JBR25CLHFCQUFNLE1BQU07b0JBQ3pCLDJDQUEyQztvQkFDM0Msd0JBQXdCLENBQ3pCLEVBQUE7O29CQUhLLE1BQU0sR0FBRyxTQUdkO29CQUVELHNCQUFPLE1BQU0sQ0FBQyxPQUFPLEVBQUM7Ozs7Q0FDdkIiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgYXN5bmMgZnVuY3Rpb24gaW1wb3J0UG9seWZpbGwoKTogUHJvbWlzZTxcbiAgdHlwZW9mIGltcG9ydChcIkBscGkvdGV4dC1lbmNvZGVyLWxpdGVcIikuZGVmYXVsdFxuPiB7XG4gIGNvbnN0IG1vZHVsZSA9IGF3YWl0IGltcG9ydChcbiAgICAvKiB3ZWJwYWNrQ2h1bmtOYW1lOiAndGV4dC1lbmNvZGVyLWxpdGUnICovXG4gICAgXCJAbHBpL3RleHQtZW5jb2Rlci1saXRlXCJcbiAgKTtcblxuICByZXR1cm4gbW9kdWxlLmRlZmF1bHQ7XG59XG4iXX0=